import React from 'react'

const Manual_filtrar_usuarios_grupo = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          ¿Cómo filtrar usuarios por grupo?
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Descubre cómo aplicar filtros por grupo de usuarios para segmentar tu base de clientes fácilmente.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_filtrar_usuarios_por_grupo__yQcE9kz5Tq6YDucix8_bbA?as=scrollable"
          className="scribe-iframe-general-91"
          width="100%"
          height="4000"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_filtrar_usuarios_grupo
